export const getIconColor = (isActive: boolean) => (isActive ? 'primary' : 'inherit');
